import { api } from '../base';
import { 
  ProjectSchema, 
  CreateProjectRequestSchema,
  type Project, 
  type CreateProjectRequest 
} from '../types';
import { z } from 'zod';

export class ProjectsApi {
  async getAll(): Promise<Project[]> {
    const response = await api.get('/v1/projects');
    return z.array(ProjectSchema).parse(response);
  }

  async getById(id: number): Promise<Project> {
    const response = await api.get(`/v1/projects/${id}`);
    return ProjectSchema.parse(response);
  }

  async create(data: CreateProjectRequest): Promise<Project> {
    const validated = CreateProjectRequestSchema.parse(data);
    const response = await api.post('/v1/projects', validated);
    return ProjectSchema.parse(response);
  }

  async update(id: number, data: Partial<CreateProjectRequest>): Promise<Project> {
    const response = await api.put(`/v1/projects/${id}`, data);
    return ProjectSchema.parse(response);
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/v1/projects/${id}`);
  }

  async getStats(projectId: number): Promise<{
    bucketCount: number;
    totalFiles: number;
    totalSize: string;
    totalSizeBytes: number;
    avgFileSize: string;
    largestBucket?: {
      name: string;
      size: string;
      fileCount: number;
    };
  }> {
    return api.get(`/v1/projects/${projectId}/stats`);
  }
}